export enum SharedListOpCodeEnum {
    ADD_TO_LIST_EXISTING_LIST = 10,
    CREATE_LIST_AND_ADD_ITEM = 20
}
